// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'status',
                    value: 'Status'
                },
                {
                    key: 'comments',
                    value: 'Comments'
                },
                {
                    key: 'dealerAccount',
                    value: 'Dealer Account'
                },
                {
                    key: 'dealerName',
                    value: 'Dealer Name'
                },
                {
                    key: 'dealerCity',
                    value: 'Dealer City'
                },
                {
                    key: 'tcsmName',
                    value: 'TCSM'
                },
                {
                    key: 'beginDate',
                    value: 'Demo/Rental Begin Date'
                },
                {
                    key: 'endDate',
                    value: 'Demo/Rental End Date'
                },
                {
                    key: 'daysOnDemoOrRent',
                    value: 'Days on demo/rent'
                },
                {
                    key: 'hoursOnDemoOrRent',
                    value: 'Hours on demo/rent'
                },
                {
                    key: 'registrationDate',
                    value: 'Registration Date'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'endDate',
                    order: 'DESC',
                    value: 'Demo/Rental End Date'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/state/views.js